

var education =  {

    currentTabIndex: 0, //当前tab位置
    isScrolling: false, //是否正在滚动
    topbannerHeight: $(".top-banner").height(),
    signupStatus: "",
    initTab: function(){
        var self = this;
        $(".tab-navigation ul li").on('click',function () {
            //阻止冒泡
            var e = window.event || arguments.callee.caller.arguments[0];
            e.stopPropagation();
            var index = $(this).index();
            self.showList(index,true);
        })
    },

    scrollEvent: function(){
        var self = this;
        $(window).scroll(function () {
            var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

            //tab吸顶
            if (scrollTop < self.topbannerHeight) {
                $('.tab-navigation').removeClass('tab-navigation-fixed');
                $(".list-module-box").eq(0).css('margin-top','0');
            } else {
                $('.tab-navigation').addClass('tab-navigation-fixed');
                $(".list-module-box").eq(0).css('margin-top','0.84rem');
            }

            var offsetTopList1 = $("#list-module-box-1").offset().top;
            var offsetTopList2 = $("#list-module-box-2").offset().top;
            var offsetTopList3 = $("#list-module-box-3").offset().top;
            //加一个tab高度，否则挡住标题才能会触发tab切换
            scrollTop += $(".tab-navigation").height();

            if (scrollTop < self.topbannerHeight && self.currentTabIndex != 0 && !self.isScrolling){
                self.showList(0);
            } else if(scrollTop >= offsetTopList1 && scrollTop < offsetTopList2 && self.currentTabIndex != 1 && !self.isScrolling){
                self.showList(1);
            }else if(scrollTop >= offsetTopList2 && scrollTop < offsetTopList3 && self.currentTabIndex != 2 && !self.isScrolling){
                self.showList(2);
            }else if(scrollTop >= offsetTopList3 && self.currentTabIndex != 3 && !self.isScrolling){
                self.showList(3);
            }

        });
    },

    //点击tab 跳转锚点
    //istabEvent 是否是tab事件触发
    showList: function(index,istabEvent){
        var self = this;
        this.currentTabIndex = index;

        var indicatorleft = index * 0.25 * $('body').width();

        $(".tab-navigation ul li").removeClass("selected");
        $(".tab-navigation ul li").eq(index).addClass("selected");
        $(".indicator").animate({left: indicatorleft+'px'},300);

        // $(".tab-navigation ul li").css('font-size','0.2rem');
        // $(".tab-navigation ul li").eq(index).animate({fontSize: '0.3rem'}, 300,'',function () {
        //
        // });

        if (istabEvent){

            self.isScrolling = true;

            if (index == 0){
                $('html, body').animate({scrollTop: 0}, 300,'',function () {
                    self.isScrolling = false;
                });
                return false;
            }

            $('html, body').animate({scrollTop: document.getElementById("list-module-box-"+index).offsetTop - 40}, 300, '', function () {
                self.isScrolling = false;
            })

        }

    },

    //发送下载资料到邮箱
    sendFileWithEmail: function(fileId,fileName){
        var isfrom = _this.signupStatus;
        if (isfrom == "allow") {
            window.location.href = "https://smarket.dellemc-solution.com/u/pc4536c43254l9083?backUrl=" + encodeURIComponent(window.location.href);
            return;
        }
        var email = $.cookie('video_download_email') || '';

        //参数
        var option = {
            articleId: '',
            fileList: [fileId],
            email: email,
            forEmailTemp: false,
            emailSubject: window.cateData.email.emailSubject,
            senderEmail: window.cateData.email.senderEmail,
            senderName: window.cateData.email.senderName,
            sess: window.cateData.userInfo.sess,
            openId: getUserInfo.options.openId,
            referenceUrl: window.location.href,
            instanceId: 0,
            moduleType: 0,
            extra: {
                tenantId: window.cateData.tenantId,
                instanceId: 0,
                memberId: window.cateData.userInfo.memberId,
                moduleId: 0,
                openId: getUserInfo.options.openId,
                weChatId: window.cateData.weChatId,
                objInstanceId: 0,
                source: window.cateData.device,
            },
            globalUserId: getUserInfo.options.globalUserId,
            browseInfo: client.browseInfo,
        };

        msg.dialogSedfile('', email, function (confirmEmail) {

            if (option.email != confirmEmail){
                //如果cookie记录的email与要发送的email不一样，则记录新的email cookie
                $.cookie('video_download_email',confirmEmail,{
                    expires: 7,
                    domain: '.dellemc-solution.com'
                })
            }
            option.email = confirmEmail;
            postJson(window.cateData.api.downloadWithEmail, option, function (data) {
                if (data.body.result !== 0) {
                    msg.toast(data.body.desc);
                    //用户行为
                    userAction.download('下载失败');
                } else {
                    //用户行为
                    userAction.download(fileName);
                    msg.toastSedfile();
                }
            });
        });
    },

    //15s视频
    showAutoPlayVideo: function(){
        //只播放一次
        if (!localStorage.getItem('autoplayed')) {
            setTimeout(function () {
                filelist.video('https://dellvideo.smarket.net.cn/video/3d7a07d2-16b88534bd0-0006-7737-ac3-9ea81.mp4',
                    '数聚制新 智能+速', '', '', '',15);
                localStorage.setItem('autoplayed','yes')
            },1000)
        }
    },

    init: function () {
        this.initTab();
        this.scrollEvent();

        //发送邮件弹窗文字修改
        $(".act-sendfile-dialog .dialog-content").html('请填写您的邮箱地址，<br/>我们会发送下载链接至您的邮箱。');

        this.caselistload();
        var globalCookie = $.cookie('globalUserId');
        self = this;
        $.ajax({
            type: "POST",
            url: window.smk_api_host + '/customForm/get',
            dataType: "json",
            contentType: 'application/json',
            data: {
                customFormId: '4536',
                globalUserId: globalCookie,
                tenantId: '444'
            },
            success: function (data) {
               
                
                self.signupStatus = data.body.content.signupStatus
                console.log(self.signupStatus);
            },
            error: function (data) {
                console.log('error');
            }
        });
    }
}
